import React from "react";
import { useTranslation } from "react-i18next";
import { MotionModal, ModalCloseButton } from "../../../../../../components/motion";

const DiscardEditConfirmationModal = ({
    show,
    onClose,
    handleDiscardEdit,
    isSubmittingModification
}) => {
    const { t } = useTranslation();
    return (
        <MotionModal
            show={show}
            onClose={onClose}
            maxWidthClassName="tw:max-w-[660px]"
            panelClassName="tw:px-4 tw:py-5 tw:md:px-10 tw:md:py-8"
        >
                <ModalCloseButton onClick={onClose} />

                <div className="tw:!text-center tw:!mt-4 tw:!mb-6">
                    <p className="tw:!text-[#282828] tw:!mb-2 tw:!text-[18px] tw:!font-[600] tw:font-hanken-grotesk tw:max-w-full">
                        {t("editBooking.BookingReviewPage.discardConfirmationModal.title")}
                    </p>
                    <p className="tw:!text-[#8D8D8D] tw:!mb-0 tw:!text-[15px] tw:!font-[400] tw:font-hanken-grotesk">
                        {t("editBooking.BookingReviewPage.discardConfirmationModal.subtitle")}
                    </p>
                </div>

                <div className="tw:flex tw:flex-col tw:lg:flex-row tw:items-stretch tw:gap-2">
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isSubmittingModification}
                        className="tw:flex-1"
                    >
                        <div className="tw:!py-3 tw:w-full tw:md:flex-1 tw:rounded-[8px] tw:border tw:border-[#d0d0d0] tw:bg-white tw:text-[#282828] tw:text-[15px] tw:leading-[22px] tw:font-medium tw:font-hanken-grotesk tw:flex tw:items-center tw:justify-center">
                            {t("editBooking.BookingReviewPage.discardConfirmationModal.back")}
                        </div>
                    </button>
                    <button
                        type="button"
                        onClick={handleDiscardEdit}
                        disabled={isSubmittingModification}
                        className="tw:flex-1"
                    >
                        <div className="tw:!py-3 tw:w-full tw:md:flex-1 tw:rounded-[8px] tw:bg-[#ef4136] tw:text-white tw:text-[15px] tw:leading-[22px] tw:!font-[700] tw:font-hanken-grotesk tw:flex tw:items-center tw:justify-center">
                            {t("editBooking.BookingReviewPage.discardConfirmationModal.discardEdit")}
                        </div>
                    </button>
                </div>
        </MotionModal>
    );
};

export default DiscardEditConfirmationModal;
